import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasAuthenticatedSession, isGuestUser } from '../utils/guestLogin';

const AuthRoute = () => {
  const { userData } = useSelector(state => state.auth);
  const location = useLocation();
  const hasSession = hasAuthenticatedSession(userData);
  const guestUser = isGuestUser(userData);

  if (location.pathname === '/login') {
    return <Outlet />;
  }

  // ✅ Already logged in as non-guest → home redirect
  if (hasSession && !guestUser) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
